import { Box, styled } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
  textUnderline: {
    cursor: "pointer",
    userSelect: "none",
    msUserSelect: "none",
    MozUserSelect: "none",
    WebkitUserSelect: "none",
    textDecoration: "underline dotted",
    textDecorationColor: "#202020",
    textUnderlineOffset: "2px",
  },
  inputBase: {
    color: "#000 !important",
    width: "50px",
    fontSize: "12px !important",
    fontWeight: 600,
    "& input": { padding: "0 !important" },
  },
}));

export const Row = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isOpen" && prop !== "noBorder",
})<{ isOpen?: boolean; noBorder?: boolean }>(({ isOpen, noBorder }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  minHeight: "29px",

  "&:not(:last-of-type)": {
    borderBottom: "1px solid #181D1F26",
    borderColor: isOpen || noBorder ? "transparent" : "#181D1F26",
  },

  "> div:nth-of-type(2)": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "2px 4px 2px 4px",
  },

  "& svg": {
    transform: isOpen ? "rotate(-180deg)" : "rotate(0deg)",
    transition: "transform 0.2s linear",
  },
}));

export const Label = styled(Box, {
  shouldForwardProp: (prop) => prop !== "underLined" && prop !== "noBorder",
})<{ underLined?: boolean; noBorder?: boolean }>(
  ({ underLined, noBorder }) => ({
    display: "inline-flex",
    flexWrap: "wrap",
    alignItems: "center",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: 0,
    color: "#000",
    borderRight: noBorder ? "none" : "1px solid #181D1F26",
    padding: "2px 4px 2px 4px",
    ...(underLined && {
      cursor: "pointer",
      userSelect: "none",
      msUserSelect: "none",
      MozUserSelect: "none",
      WebkitUserSelect: "none",
      // textDecoration: "underline dotted",
      textDecoration: "underline",
      textDecorationColor: "#202020",
      textUnderlineOffset: "2px",
    }),
  })
);

export const PanelLabel = styled(Label, {
  shouldForwardProp: (prop) => prop !== "crossLined",
})<{ crossLined?: boolean }>(({ crossLined }) => ({
  marginLeft: "20px",
  ...(crossLined && { textDecoration: "line-through" }),
}));

export const Panel = styled(Box, {
  shouldForwardProp: (prop) => prop !== "hidden",
})<{ hidden?: boolean }>(({ hidden }) => ({
  overflow: "hidden",
  transition: "all 0.3s ease-in-out",
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: "#181D1F26",
  maxHeight: hidden ? "1px" : "1000px",
}));

export const PanelRow = styled(Row)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
  border: "none !important",
  minHeight: "22px !important",

  "> div:nth-of-type(2)": {
    paddingRight: "20px",
  },
}));
